import './CIAMCaseStudy.css';

const observations = [
  'Multiple post-login rules executing sequentially',
  'Static, non-contextual MFA enforcement',
  'Authorization group mapping running after token issuance',
  'Customer notifications dependent on synchronous calls',
];

const outcomes = [
  'Login success perception improved and support tickets dropped',
  'MFA adoption became measurable with clearer risk signals',
  'Authentication events gained observability across teams',
  'Identity workflow scaled without blocking session creation',
];

const monitors = [
  'CloudWatch metrics for Lambda execution latency and SMS delivery failures',
  'Authentication spike tracking to protect peak windows',
  'Sentinel KQL for abnormal MFA surges and retry patterns',
  'Onboarding stability detection and trend visibility',
];

const flow = [
  'User Login → Auth0 verifies identity',
  'Context evaluated (device / login pattern)',
  'Adaptive MFA triggered only if risk signal exists',
  'Token issued (non-blocking)',
  'Post-login action emits event payload',
  'AWS Lambda processes notification',
  'SNS delivers SMS alert',
];

const CIAMCaseStudy = () => {
  return (
    <section className="section" id="ciam-case">
      <div className="container ciam">
        <div className="section-header">
          <div>
            <h2>Engineering Event-Driven CIAM Workflow</h2>
            <p>Real-world optimization of Auth0 Actions and AWS serverless to keep authentication non-blocking during a 70k-user migration wave.</p>
          </div>
        </div>

        <div className="ciam-grid">
          <article className="ciam-card">
            <div className="tag">Context</div>
            <h3>When post-auth became the bottleneck</h3>
            <p>
              During a CIAM onboarding surge, federation was stable but session establishment lagged. Sequential rules, static MFA, and synchronous notifications created latency that felt like login failures.
            </p>
            <ul className="bullet-list">
              {observations.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>

          <article className="ciam-card">
            <div className="tag">Engineering Decision</div>
            <h3>Decoupled, event-driven orchestration</h3>
            <p>
              We rebuilt the journey with Auth0 Actions, separated enforcement from comms, and kept token issuance unblocked while delegating notifications to Lambda + SNS.
            </p>
            <div className="flow">
              {flow.map((step) => (
                <div className="flow-step" key={step}>{step}</div>
              ))}
            </div>
          </article>

          <article className="ciam-card">
            <div className="tag">Observability</div>
            <h3>Monitoring that matches the workflow</h3>
            <p>
              Identity signals were streamed to CloudWatch and Sentinel to expose risk, retry loops, and onboarding instability before they became incidents.
            </p>
            <ul className="bullet-list">
              {monitors.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>

          <article className="ciam-card">
            <div className="tag">Business Impact</div>
            <h3>What stakeholders actually felt</h3>
            <p>
              The conversation shifted from perceived SSO instability to measurable identity outcomes that informed platform decisions.
            </p>
            <ul className="bullet-list">
              {outcomes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
};

export default CIAMCaseStudy;
